import { render, staticRenderFns } from "./Thank.vue?vue&type=template&id=101b6d34&scoped=true&"
import script from "./Thank.vue?vue&type=script&lang=js&"
export * from "./Thank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b6d34",
  null
  
)

export default component.exports